
import React from "react";
import { Routes, Route, Link, useNavigate } from "react-router-dom";
import { routes } from "../helpers/constants";
import Home from "../views/Home";
import logo2 from "../assets/logo2.png";
import { PropertiesProvider } from "../contexts/properties";
import Listing from "../views/Listing";
import About from "../views/About";
import TermsOfService from "../views/TermsOfService";
import PlatformUsageAgreement from "../views/PlatformUsageAgreement";
// import Blog from "../views/Blog/Blog";
import { Layout, FloatButton, Menu, Typography } from "antd";
import './menuwrapper.css'
import ContactCard from "./ContactCard";
// import Post1 from '../views/Blog/Post1';
// import Post2 from '../views/Blog/Post2';
// import Post3 from '../views/Blog/Post3';
// import Post4 from '../views/Blog/Post4';


const { Header, Footer } = Layout;

function MenuWrapper() {
  const navigate = useNavigate();

  const onMenuClick = (e: any) => {
    navigate(e.key === 'home' ? '/' : e.key);
  };

  return (
    <Layout className="layout">
      <Header
        style={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "#001B71",
        }}
      >
        <Link to="/">
          <img
            className="logo"
            src={logo2}
            alt="blockapps logo"
            style={{ width: 170, marginTop: 28 }}
          />
        </Link>
        <Menu
          onClick={onMenuClick}
          className="menu-bar"
          style={{ backgroundColor: "rgb(0, 27, 113)", marginLeft: "20px" }}
          theme="dark"
          mode="horizontal"
          defaultSelectedKeys={["home"]}
          items={[
            { key: "home", label: "Home" },
            // { key: "blog", label: "Blog" },
            { key: "about", label: "About" },
          ]}
        />
      </Header>
      <Routes>
        <Route
          path={routes.HOME}
          element={
            <PropertiesProvider>
              <Home />
            </PropertiesProvider>
          }
        />
        <Route
          path={routes.ABOUT}
          element={
            <About />
          }
        />
        <Route
          path={routes.LISTING}
          element={
            <PropertiesProvider>
              <Listing />
            </PropertiesProvider>
          }
        />
        <Route
          path={routes.TERMS}
          element={
            <TermsOfService />
          }
        />
        <Route
          path={routes.USAGE}
          element={
            <PlatformUsageAgreement />
          }
        />
        {/* <Route
          path={routes.BLOG}
          element={
            <Blog />
          } />
        <Route path={routes.BLOG1} element={
          <Post1 />
        } />
        <Route path={routes.BLOG2} element={
          <Post2 />
        } />
        <Route path={routes.BLOG3} element={
          <Post3 />
        } />
        <Route path={routes.BLOG4} element={
          <Post4 />
        } /> */}

      </Routes>
      <FloatButton.BackTop />
      <Footer style={{ textAlign: 'center', marginTop: 25 }}>
        <PropertiesProvider>
          <ContactCard />
        </PropertiesProvider>
        <div style={{ marginTop: 20 }}>Mercata Properties ©2023 Created by BlockApps</div>
        <Link to='/termsofservice'>Terms of Service</Link>
        <Typography.Text> | </Typography.Text>
        <Link to='/platformusageagreement'>Platform Usage Agreement</Link>
      </Footer>
    </Layout>
  )
}

export default MenuWrapper;
